import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Typography from '@ui/Typography';

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: theme.spacing(12.5),
    backgroundColor: theme.palette.grey[800],
    padding: theme.spacing(0.5, 1),
  },
  greenDot: {
    height: theme.spacing(1),
    width: theme.spacing(1),
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    marginRight: theme.spacing(1),
  },
}));

const OnIndicator = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.greenDot}> </Box>
      <Typography variant="pMd" color="primary">
        On
      </Typography>
    </Box>
  );
};

export default OnIndicator;
